import { Component } from '@angular/core';

@Component({
  selector: 'app-references-quotations',
  templateUrl: './references-quotations.component.html'
})
export class ReferencesQuotationsComponent {
}
